import { REFRESH_DATABASE } from '../../store/constants/database';

export function refreshDatabase() {
  return {
    type: REFRESH_DATABASE,
  };
}
